import React from 'react';
import fn from '../../Functii'
import moment from 'moment'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

class TeaserText extends React.Component {
    render() {
        if (this.props.multiLang) {
            
            return (
                <div className="teaser_text_container">
                    <div className="orange_txt">{this.props.multiLang.cursaLoteriilor.txt}</div>
                    <div className="bue_txt">
                    {this.props?.widgetPromotie?.start && this.props?.widgetPromotie?.end ? <div>{moment(this.props.widgetPromotie.start).format('DD/MM/YYYY') + ' - ' + moment(this.props.widgetPromotie.end).format('DD/MM/YYYY')}</div> : null}
                    {this.props?.widgetPromotie?.total_prize_value ? <div><span className="cash">{fn.points(parseInt(this.props.widgetPromotie.total_prize_value)) + ' ' + this.props.defaultVal.currency}</span> {this.props.multiLang.premiiCash.txt}</div> : null}
                    </div>
                </div>
            )
        } else return <div></div>
    }
}

function mapStateToProps(state) {
    return {
        multiLang: state.multiLang,
        widgetPromotie: state.widgetPromotie,
        defaultVal: state.defaultVal
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
    }, dispatch)
}
export default connect(mapStateToProps, matchDispatchToProps)(TeaserText);

// export default TopWiners